import {
  useLoadingEffect,
  LoadingProps,
  LoadingTemplateProps,
  LoadingDefaultTemplate,
} from '../';

export const LoadingElement = (props: LoadingProps) => {
  const [state] = useLoadingEffect(props);

  const templateProps: LoadingTemplateProps = {
    type: props.type,
    width: props.width,
    height: props.height,
    ...state,
  };

  let template;
  switch (props.template) {
    case 'loadingDefault':
    default:
      template = LoadingDefaultTemplate(templateProps);
      break;
  }

  return template;
};
